/* eslint-disable */
import React, { useEffect, useState, useContext, useRef }from 'react';
import Card from '../../components/card.component';
import {
  Row,
  Col
} from 'react-bootstrap';
//import { useForm } from "react-hook-form";
import notification from '../../components/notification.component';
import tableMaster from '../master/master.table';
import DataTable from 'react-data-table-component';
import masterFunction from '../master/master.functions';
import pad from 'pad';
import { ConfigContext } from '../../context/config.context';
import Modal from '../../components/modal/modal.component';
import EstadosGuias from '../../components/estadomaster.component';
import ConfirmAlert from '../../components/confirm.component';
import { useHistory } from 'react-router-dom';
import utils from '../../utils/utils.functions';
import CompleteMaster from '../../components/entrega/completeMaster.component';
import { ConfigContextUtils } from '../../context/contextUtils.context';


const Estados = () => {

  const history = useHistory();
  const guiaMaster = useRef();

  const { setPreloader } = useContext(ConfigContextUtils);
  const { config } = useContext(ConfigContext);
  const [listadoMaster, setListado] = useState([]);
  const [estadosMaster, setEstadosMaster] = useState([]);
  const [changeMaster, setChangeMaster] = useState(false);
  const [clearSelect, setClearSelect] = useState(false);
  const [confirm, setConfirm] = useState(false);
  const [fullDelivery, setFullDelivery] = useState(true);
  const [master, setMaster] = useState({
    id: null,
    text: '',
  });
  const [seleccionados, setSeleccionados] = useState({
    selectedCount: 0,
    selectedRows: [],
  });
  const [modalShow, setModalShow] = useState(false);
 
  const listaMaster = () => {
    masterFunction.listadoFiltro().then((response) => {
      setListado(response);
    })
  }

  useEffect(() => {
    listaMaster();
  },[])


  const refreshData = (id) => {
    buscarEstadosMaster({
      target: {
        value: id 
      }
    })
  }

  const buscarEstadosMaster = (element) => {
    if (element.target.value === 'null') {
      setEstadosMaster([]);
      setChangeMaster(false);
    } else {
      setPreloader(true);
      masterFunction.estadosMaster({id: element.target.value}).then((response) => {
        if (response.data.estados) {
          const boolMaster = response.data.estados.guias_of_master.length ? true : false;
          setEstadosMaster(response.data.estados);
          setChangeMaster(boolMaster);
          setFullDelivery(!boolMaster);
        }
        setPreloader(false);
      });
    }
    setSeleccionados({
      selectedCount: 0,
      selectedRows: [],
     });
    setMaster({ 
      id: element.target.value,
      text: getTextSelected()
    })
    setClearSelect(!clearSelect);
  }

  const getTextSelected = () => {
    return guiaMaster.current.options[guiaMaster.current.options.selectedIndex].text;
  }

  const guiasSeleccionadas = (rows) => {
    setSeleccionados(rows);
  }

  const actualizarEstados = (e) => {
    masterFunction.estadosMaster({id: e}).then((response) => {
      setEstadosMaster(response.data.estados);
      setChangeMaster(response.data.estados.guias_of_master.length ? true : false);
    });
    setModalShow(false);
    setClearSelect(!clearSelect);
  }

  const validatePaqueteFullEntregados = () => {
    let full = true;
    if (changeMaster) {
      estadosMaster.guias_of_master.map((e) => {
        if (!e.guia_finalizada) {
          full = false;
        }
      })
    } else {
      full = false;
   }
    return full;
  }

  const calculatePaquetesEntregados = () => {
    if (changeMaster) {
      const total = estadosMaster.guias_of_master.length;
      let progreso = 0;
      estadosMaster.guias_of_master.map((e) => {
        if (e.guia_finalizada) {
          progreso += 1;
        }
      })
      return `${progreso}/${total}`;
    } else {
      return '0/0';
    }
  }

  const confirmHandle = () => {
    masterFunction.cierreGuiaMaster({ id: master.id}).then((respuesta) => {
      if (respuesta.cierre_guia_master) { 
        notification.success();
        setConfirm(false);
        setChangeMaster(false);
        setEstadosMaster([]);
        listaMaster();
      } else {
        notification.warning('Intentelo nuevamente ocurrio un problema.');
      }
    })
  }


  return (
  <>
    <Row>
      <Col lg={6}>
        <Card>
          <Row>
            <Col> 
                <div className="grupo-input">
                  <small>Seleccione una guia master</small>
                  <select ref={guiaMaster} className="form-control" onChange={buscarEstadosMaster}>
                    <option value="null">Seleccione...</option>
                   {listadoMaster.map((e) => {
                      return <option key={e.id} value={e.id}>{pad(5,e.id,'0')} - {e.rel_tipos.description} - {e.description}</option>
                    })};
                  </select>
                </div>
            </Col>
          </Row>
        </Card>
      </Col>
      <Col lg={6}>
        <Card>
          <Row>
            <Col>
              <div className="d-flex justify-content-between">
                <div className="d-flex">
                  <div className="grupo-input d-flex flex-column mr-3 text-center">
                    <small>Total de guias</small>
                    {changeMaster ? estadosMaster.guias_of_master.length : 0 }
                  </div>
                  <div className="grupo-input d-flex flex-column text-center">
                    <small>Progreso entrega</small>
                  {calculatePaquetesEntregados()}
                  </div>
                </div>
                <div>
                  <div className="grupo-input d-flex flex-column text-center align-self-end">
                    <button 
                        onClick={() => history.replace('/traspaso')}
                        type="button"
                        className="btnx btnx-warn btn-block"
                      >
                        Traspaso de guias
                    </button>
                    <CompleteMaster
                      buttonText={'Completar entrega'}
                      styleBtn={'mt-2 btn-block'}
                      disabled={fullDelivery ? true :  validatePaqueteFullEntregados() }
                      master_id={master.id}
                      onConfirm={(val) => refreshData(val)}
                    />
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </Card>
      </Col>
    </Row>

    <Row className="mt-3">
    <Col lg={12}>
     <Card>
      <Row>
        <Col>
          <DataTable
            title="Estado guia master"
            customStyles={tableMaster.customStyles}
            columns={tableMaster.columnEstadosMasterOriginal}
            data={estadosMaster.estados_master}
            dense={true}
            pagination={true}
            noHeader={false}
            subHeader={changeMaster}
            noDataComponent={"Sin datos asociados"}
            subHeaderComponent={
              <button 
               onClick={() => setConfirm(true)}
               type="button"
               className="btnx btnx-warn"
               disabled={!validatePaqueteFullEntregados()}
              >
                 Cerrar guia
              </button>
           }
          />
        </Col>
       </Row>
      </Card>
     </Col>
    </Row>

    <Row className="mt-3">
    <Col lg={12}>
     <Card>
      <Row>
        <Col>
           <DataTable
            title="Guias asociadas"
            customStyles={tableMaster.customStyles}
            columns={tableMaster.columnEstadosMaster(config.prefijo_correlativo_guia, utils.obtenerValorPermiso('USE_PREFIX_TYPE_SENDING', config.operaciones))}
            data={estadosMaster.guias_of_master}
            dense={true}
            pagination={true}
            subHeader={changeMaster}
            selectableRows={true}
            selectableRowsHighlight={true}
            noDataComponent={"Sin datos asociados"}
            clearSelectedRows={clearSelect}
            contextMessage={{
              singular: 'Guia',
              plural: 'Guias',
              message: 'seleccionadas',
            }}
            selectableRowDisabled={row => row.guia_finalizada || row.guia_pendiente || row.guia_anulada ? true : false}
            onSelectedRowsChange={guiasSeleccionadas}
            subHeaderComponent={
               <button 
                onClick={() => setModalShow(true)}
                type="button"
                className="btnx btnx-warn"
                disabled={seleccionados.selectedCount > 0 ? false : true}
               >
                  Cambiar de estado
               </button>
            }
          />
        </Col>
       </Row>
      </Card>
     </Col>
    </Row>
    <Modal show={modalShow}>
        <Card>
            <div>
              <EstadosGuias 
                onClose={() => setModalShow(false)}
                onUpdate={(e) => actualizarEstados(e)}
                datos={seleccionados}
                master={master}
                guias={changeMaster ? estadosMaster.guias_of_master : 0}
                show={modalShow}
              />
            </div>
        </Card>               
      </Modal>
      <ConfirmAlert
        show={confirm}
        message=""
        onCancel={() => setConfirm(false)}
        onConfirm={() => confirmHandle()}
      />
    </>
  )
}

export default Estados;